// Глобальный action для сброса состояния всего Redux-стора.
//
// Использование:
//   dispatch(resetStore())
//
// Как это работает:
// - Каждый slice, который должен сбрасываться, добавляет обработку этого action через:
//     extraReducers: (builder) => { builder.addCase(resetStore, () => initialState); }
// - Когда вызывается dispatch(resetStore()), все такие слайсы сбрасывают своё состояние к начальному (initialState).
// - Это удобно для выхода пользователя (logout), сброса при ошибках, очистки данных и т.д.
//
// Важно:
// - Если slice не обрабатывает resetStore, его состояние сброшено не будет.
// - Добавляйте обработку resetStore во все новые слайсы, если хотите, чтобы они сбрасывались.

import { createAction } from '@reduxjs/toolkit';

const resetStore = createAction('resetStore');
export default resetStore;
